export default {"src":"/_next/static/media/mongodb_logo_83f2d5a1bc.d45b3a79.svg","height":160,"width":320,"blurWidth":0,"blurHeight":0};